import type { CopyShape } from "@tami/core/intl";

import type { CAMPANHAS_SCRIPT_COPY_PT_BR } from "../campanhas-script.copy";

export const CAMPANHAS_SCRIPT_COPY_EN_US: CopyShape<typeof CAMPANHAS_SCRIPT_COPY_PT_BR> = {
  campIntro: {
    narrative: "Campaign hub: every brand partnership organized from first contact to wrap-up.",
  },
  campGrid: {
    narrative: "Keep the brief, contacts, amounts and deliverables on a single card — and track every stage of the deal.",
    callout: "Brief, contacts and amounts for each brand — from 'Chatting' to 'Wrapped up'.",
  },
  campModalOpen: {
    narrative: "Add a new campaign in seconds — name, brand, deadline and context in a guided flow.",
    callout: "Campaign modal: organize partnerships without leaving the Campaign hub.",
  },
  campModalTitle: {
    narrative: "Start with the campaign name — collection, launch or collab, everything's easy to find later.",
    callout: "Give the campaign a clear name — the starting point of every deal.",
  },
  campModalBrand: {
    narrative: "Link the partner brand and keep a history of every business relationship.",
    callout: "Log which brand is behind the campaign — key for reports and finances.",
  },
  campModalDeadline: {
    narrative: "Set the end date and jot down the context — brief and rules in one place.",
    callout: "Campaign deadline and context — zero surprises when it's time to deliver.",
  },
  campModalDeliverables: {
    narrative: "In the Deliverables tab, log every piece of the campaign: network, format, due date and amount.",
    callout: "Each deliverable with platform, format and due date — a clear scope from day one.",
  },
  campModalDeliverablesList: {
    narrative: "All deliverables in one table — status, due dates and amounts visible at once.",
    callout: "Scope summary by network — Reels, videos and stories organized by platform.",
  },
  campModalPayment: {
    narrative: "In the Payment tab, split the amount across deliverables and set how you'll get paid.",
    callout: "Amount per deliverable and payment method — negotiate with the numbers on the table.",
  },
  campModalPaymentTotal: {
    narrative: "Campaign total calculated automatically — one-time or in installments, your call.",
    callout: "Combined campaign total — deliverables + extras, fully transparent.",
  },
  campOutro: {
    narrative: "Never lose track of a deal again because things got messy.",
  },
};
